import { createTtlCache } from '../helpers/helper.cache'
import { mapConsolidateInvoices } from '../helpers/helper.organisations'
import { getCommerceUserHeaders, getSessionId, getUserId } from '../helpers/helper.user'
import type { UserConsolidateInvoices } from '../types/fleet'
import type { CommerceCostCentersResponse } from '../types/integrations/commerce/common'

export const CONSOLIDATE_INVOICES_CACHE_TTL_MS = 15 * 60 * 1000
const COMMERCE_FLEET_API_URL = 'http://integration-proxy-api/commerce-fleet/api'
const consolidateInvoicesCache = createTtlCache<UserConsolidateInvoices>(CONSOLIDATE_INVOICES_CACHE_TTL_MS)

export function getConsolidateInvoices(req: any): Promise<UserConsolidateInvoices> {
  const userId = getUserId(req)
  if (!userId) return fetchConsolidateInvoices(req)

  const organisationId = req.params?.organisationId
  if (!organisationId) return fetchConsolidateInvoices(req)

  const cacheKey = [userId, getSessionId(req), organisationId].filter(Boolean).join(':')

  return consolidateInvoicesCache.get(cacheKey, () => fetchConsolidateInvoices(req))
}

export async function userHasAccessToConsolidateInvoice(req: any, code: string) {
  const { consolidateInvoices } = await getConsolidateInvoices(req)
  return consolidateInvoices.some((consolidateInvoice) => consolidateInvoice.code === code)
}

async function fetchConsolidateInvoices(req: any): Promise<UserConsolidateInvoices> {
  const response = await fetch(`${COMMERCE_FLEET_API_URL}/OmkostningscenterApi/GetAvailableCostCentersForUser`, {
    method: 'GET',
    headers: getCommerceUserHeaders(req),
  })

  const { ok, status } = response
  if (!ok) throw new Error(`Failed to fetch consolidate invoices: ${status} - ${await response.text()}`)

  const body: CommerceCostCentersResponse = await response.json()
  if (body.Success === false) throw new Error(`Failed to fetch consolidate invoices: ${body.ErrorMessage}`)

  return mapConsolidateInvoices(body)
}
